import useCartStore from "../../utils/cartStore";
import { useState } from "react";

const GOUTS_ENROBAGE = [
  { id: "lait",  label: "Chocolat au Lait", color: "#C68642" },
  { id: "blanc", label: "Blanc",            color: "#F5F0E8" },
  { id: "gold",  label: "Gold",             color: "#D4AF37" },
];

const REPARTITION_VIDE = Object.fromEntries(GOUTS_ENROBAGE.map((g) => [g.id, 0]));

const FraisesCard = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);
  const [repartition, setRepartition] = useState({ ...REPARTITION_VIDE });

  const total = Object.values(repartition).reduce((a, b) => a + b, 0);
  const restant = 12 - total;
  const pret = total === 12;

  const handleIncrease = (id) => {
    if (restant <= 0) return;
    setRepartition((prev) => ({ ...prev, [id]: prev[id] + 1 }));
  };

  const handleDecrease = (id) => {
    if (repartition[id] <= 0) return;
    setRepartition((prev) => ({ ...prev, [id]: prev[id] - 1 }));
  };

  const buildDescription = () => {
    return GOUTS_ENROBAGE.filter((g) => repartition[g.id] > 0)
      .map((g) => `${repartition[g.id]}x ${g.label}`)
      .join(", ");
  };

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart({
      id: `fraises-enrobees-${Date.now()}`,
      name: "Fraises Enrobées au Chocolat",
      price: 24,
      image: "/images/fraises/fraises-enrobees.jpg",
      category: "Fraises Enrobées",
      description: buildDescription(),
    }, quantity);
    setRepartition({ ...REPARTITION_VIDE });
    setQuantity(1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6 max-w-lg mx-auto">
      <img
        src="/images/fraises/fraises-enrobees.jpg"
        alt="Fraises Enrobées au Chocolat"
        className="w-full h-64 object-cover rounded-xl mb-4"
      />
      <h2 className="text-2xl font-semibold mb-1">Fraises Enrobées au Chocolat</h2>
      <p className="text-gray-500 text-sm mb-3">Boîte de 12 fraises enrobées  personnalisez l'enrobage selon vos goûts</p>
      <p className="text-xs text-amber-700 font-medium mb-3">Disponible d'Avril à Septembre, selon l'arrivage</p>
      <p className="text-xl font-bold mb-6">24 €</p>

      {/* Répartition des 12 fraises */}
      <div className="mb-5">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Répartissez vos 12 fraises :
        </p>
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${
          pret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"
        }`}>
          {pret ? "✓ Sélection complète !" : `${restant} fraise${restant > 1 ? "s" : ""} restante${restant > 1 ? "s" : ""}`}
        </div>

        <div className="space-y-3">
          {GOUTS_ENROBAGE.map((g) => {
            const count = repartition[g.id];
            const isDark = g.id === "lait";
            return (
              <div key={g.id} className="flex items-center gap-3">
                <span
                  className="w-10 h-10 rounded-lg flex-shrink-0 border border-gray-200 flex items-center justify-center"
                  style={{ background: g.color }}
                >
                  <span className={`text-xs font-bold ${isDark ? "text-white" : "text-gray-700"}`}>
                    {g.label[0]}
                  </span>
                </span>
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleDecrease(g.id)}
                    disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${
                      count === 0
                        ? "border-gray-200 text-gray-300 cursor-not-allowed"
                        : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"
                    }`}
                  >−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button
                    onClick={() => handleIncrease(g.id)}
                    disabled={restant <= 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${
                      restant <= 0
                        ? "border-gray-200 text-gray-300 cursor-not-allowed"
                        : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"
                    }`}
                  >+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button
        onClick={handleAddToCart}
        disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${
          pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"
        }`}
      >
        {pret ? "Ajouter au panier" : "Complétez votre sélection"}
      </button>
    </div>
  );
};

const FraisesEnrobees = () => {
  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-4">Fraises Enrobées au Chocolat</h1>
      <p className="text-gray-500 mb-2">
        Des fraises fraîches enrobées de chocolat, choisissez votre enrobage.
      </p>
      <p className="text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-4 py-2 inline-block mb-10 text-sm font-medium">
        🍓 Disponible d'Avril à Septembre, selon l'arrivage
      </p>
      <div className="flex justify-center">
        <FraisesCard />
      </div>
    </div>
  );
};

export default FraisesEnrobees;